import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TiemposPlayBanner() {
  return (
    <section
      aria-labelledby="tiempos-play-heading"
      className="rounded-md bg-play-background text-play-foreground px-6 py-9 sm:px-10 sm:py-12"
    >
      <a
        href="https://play.tiemposhoy.com"
        aria-label="Tiempos Play"
        className="inline-flex items-center gap-1.5 text-xl font-extrabold focus-visible:outline focus-visible:outline-2 focus-visible:outline-play-accent"
      >
        <span>TIEMPOS</span><span className="text-play-accent">PLAY</span>
      </a>
      <div className="mt-7 flex flex-col gap-7 lg:flex-row lg:items-end lg:justify-between lg:gap-10">
        <div className="min-w-0">
          <h2 id="tiempos-play-heading" className="text-3xl font-extrabold leading-tight sm:text-4xl lg:text-5xl">
            Jugá los números.<br />
            <span className="text-play-accent">No tu dinero.</span>
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-play-muted">
            Empezá con <strong className="font-bold text-play-foreground">₡35.000 virtuales</strong> y descubrí hasta dónde podés llevarlos.
          </p>
        </div>
        <Button asChild variant="play" size="lg" className="h-12 w-full shrink-0 text-base font-bold sm:w-fit lg:mb-1">
          <a href="https://play.tiemposhoy.com">
            Jugar gratis <ArrowUpRight aria-hidden="true" />
          </a>
        </Button>
      </div>
    </section>
  );
}